import { AlertTriangle, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SupportStatus } from "@/components/SupportStatus";
import { useModalFocus } from "@/lib/useModalFocus";

export const SupportDeleteDialog = ({ impact, busy, error, onCancel, onConfirm, returnFocusRef }) => {
  const { dialogRef, onKeyDown } = useModalFocus(onCancel, busy, returnFocusRef);
  return <div ref={dialogRef} onKeyDown={onKeyDown} tabIndex={-1}
       className="fixed inset-0 z-[110] bg-[#111]/65 flex items-center justify-center px-4 py-6"
       role="dialog" aria-modal="true" aria-labelledby="support-delete-title"
       data-testid="support-delete-modal">
    <div className="w-full max-w-lg bg-[#FAF9F6] p-6 sm:p-8 shadow-2xl max-h-[90vh] overflow-y-auto">
      <div className="flex gap-3 items-start">
        <AlertTriangle className="w-6 h-6 text-[#9C3730] shrink-0" />
        <div className="min-w-0">
          <h2 id="support-delete-title" className="font-serif text-2xl text-[#1A1A1A]" data-testid="support-delete-heading">
            Eliminare definitivamente il ticket?
          </h2>
          <p className="text-sm text-[#575757] mt-2 break-words" data-testid="support-delete-subject">{impact.subject}</p>
        </div>
      </div>
      <dl className="border-y border-[#DEDCD5] my-6 py-4 grid gap-2 text-sm">
        <div className="flex justify-between gap-3"><dt>Cliente</dt><dd className="text-right break-words min-w-0" data-testid="support-delete-customer">{impact.customer}</dd></div>
        <div className="flex justify-between gap-3"><dt>Azienda</dt><dd className="text-right break-words min-w-0" data-testid="support-delete-company">{impact.company}</dd></div>
        <div className="flex justify-between gap-3"><dt>Stato</dt><dd data-testid="support-delete-status">
          <SupportStatus status={impact.status} testId="support-delete-status-badge" />
        </dd></div>
        <div className="flex justify-between gap-3"><dt>Messaggi</dt><dd data-testid="support-delete-message-count">{impact.message_count}</dd></div>
        <div className="flex justify-between gap-3"><dt>Allegati su Aruba</dt><dd data-testid="support-delete-attachment-count">{impact.attachment_count}</dd></div>
        <div className="flex justify-between gap-3"><dt>Notifiche interne</dt><dd data-testid="support-delete-notification-count">{impact.notification_count}</dd></div>
      </dl>
      <p className="text-sm text-[#8C3A3A] leading-relaxed" data-testid="support-delete-warning">
        Ticket, conversazione, notifiche e allegati saranno eliminati in modo permanente. Il cliente e il suo account rimarranno intatti.
        Le email già recapitate non possono essere revocate.
      </p>
      {impact.deletion_in_progress && <p className="text-xs mt-3 text-[#8C3A3A]" role="status"
        data-testid="support-delete-retry-info">Un'eliminazione precedente non è terminata. Puoi riprovare.</p>}
      {error && <p className="text-sm text-[#8C3A3A] mt-4" role="alert" data-testid="support-delete-error">{error}</p>}
      <div className="flex flex-col-reverse sm:flex-row justify-end gap-2 mt-7">
        <Button type="button" variant="outline" disabled={busy} onClick={onCancel}
                className="rounded-sm" data-testid="support-delete-cancel">Torna al ticket</Button>
        <Button type="button" disabled={busy} onClick={onConfirm}
                className="rounded-sm bg-[#9C3730] text-white hover:bg-[#792D28] gap-2"
                data-testid="support-delete-confirm"><Trash2 className="w-4 h-4" />
          {busy ? "Eliminazione..." : "Elimina definitivamente"}
        </Button>
      </div>
    </div>
  </div>;
};